export const Header = {
  methods: {
    //check is desktop
    isDesktop() {
      if (device.mobile()) {
        return true;
      } else {
        return false;
      }
    },
    //show mobile menu
    showMobileMenu() {
      this.mobileMenu = !this.mobileMenu;
      this.showMenu = !this.showMenu;
      if (this.mobileMenu == true) {
        this.menuLogo = require("@/assets/icon/menu-b.png");
      } else {
        this.menuLogo = require("@/assets/icon/menu-w.png");
      }
    },
    // get loggin user
    getUser() {
      var tokenId = localStorage.getItem("authToken");
      if (tokenId == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      // var user = this.$auth.getMe();
      // var cardHolderInfId = user.cardHolderInfId;
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.user = result;
            this.$auth.removeCardInfo();
            this.$auth.setCardInfo(this.user);
            this.nomin = result.isEmployee === 1;
            if (result.isDVIP === 1) {
              this.dvip = true;
            }
            this.user.isIdPhoneUpdated > 0
              ? (this.checkNumber = false)
              : (this.checkNumber = true);
            this.user.isPasswordChanged === 1
              ? ((this.checkPassword = false), (this.validated = true))
              : ((this.checkPassword = true), (this.validated = false));
            this.user.isConfirmFirst === 0
              ? (this.validated = false)
              : (this.validated = true);
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    //log out
    logout() {
      this.$insProgress.start();
      this.$auth.destroyToken();
      this.$auth.removeMe();
      this.$router.push({ name: "login" });
      this.$insProgress.finish();
      this.$auth.removeCardInfo();
      this.$auth.removeCustomerInfo();
    },
  },
};
